import Company from 'app/components/ServicesForms/Registration/Company';
import ChangeEmailRegistration from 'app/components/ServicesForms/Registration/ChangeEmail';
import InitialAccess from 'app/components/ServicesForms/Registration/InitialAccess';
import LicenseRegistration from 'app/components/ServicesForms/Licenses/LicenseRegistration';
import LicenseDuplicateRegistration from 'app/components/ServicesForms/Licenses/LicenseDuplicateRegistration';
import VehicleRegistration from 'app/components/ServicesForms/Vehicles/VehicleRegistration';
import SurveyRegistration from 'app/components/ServicesForms/Survey';
import LinesRegistration from 'app/components/ServicesForms/Lines/LinesRegistration';

import {
    accessPortalSchema,
    changeEmailSchema,
    healthLicenseValidationSchema,
    licensesEventualValidationSchema,
    licensesTourismValidationSchema,
    licensesValidationSchema,
    lineValidationSchema,
    registrationValidationSchema,
    stripLineValidationSchema,
    surveyValidationSchema,
    vehicleValidationSchema,
} from 'app/utils/forms/validationsSchemas';

import { URLS } from './urls';
import {
    accessPortalPayload,
    changeEmailPayload,
    licensePayload,
    linePayload,
    lineStripPayload,
    registrationPayload,
    surveyRequestPayload,
    vehicleRequestPayload,
} from 'app/utils/forms/payloadsStruture';

export const WITH_DETRAN = true;

export const SERVICES_CODES = {
    ACESSO_PORTAL_FISICA: 1,
    ACESSO_PORTAL_JURIDICA: 2,
    INSCRICAO_CADASTRAL: 3,
    RENOVACAO_CADASTRAL: 4,
    ATUALIZACAO_CADASTRAL_COM_CRC: 5,
    ATUALIZACAO_CADASTRAL_SEM_CRC: 6,
    SEGUNDA_VIA_CRC: 7,
    INATIVACAO_CADASTRAL: 8,
    INCLUSAO_VEICULOS_SEM_CRC: 9,
    INCLUSAO_VEICULOS: 10,
    ALTERACAO_VEICULOS: 11,
    EXCLUSAO_VEICULOS: 12,
    ALTERACAO_VEICULOS_SEM_CRC: 13,
    VISTORIA: 14,
    LAUDO_VISTORIA: 15,
    LICENCA_VIAGEM_EVENTUAL: 16,
    LICENCA_VINCULADA: 17,
    LICENCA_FRETAMENTO: 18,
    LICENCA_FRETAMENTO_TRATAMENTO_SAUDE: 19,
    LICENCA_FRETAMENTO_UNIVERSITARIOS: 20,
    LICENCA_ESCOLAR: 21,
    LICENCA_TURISMO: 22,
    LICENCA_SEGUNDA_VIA: 23,
    SLIC_MODIFICACAO_HORARIOS: 24,
    SLIC_AMPLIACAO_HORARIOS: 25,
    SLIC_SUPRESSAO_HORARIOS: 26,
    SLIC_SUBSTITUICAO_VEICULO: 27,
    SLIC_PRORROGACAO_PRAZO: 28,
    SLIC_TRANSFERENCIA_PERMISSAO: 29,
    SLIC_CANCELAMENTO_PERMISSAO: 30,
    SLIC_INCLUSAO_CONDUTOR_SUBSTITUTO: 31,
    STRIP_PROLONGAMENTO_LINHA: 32,
    STRIP_ENCURTAMENTO_LINHA: 33,
    STRIP_REFORCO_HORARIOS: 34,
    STRIP_CONEXAO_LINHAS: 35,
    STRIP_ALTERACAO_DEFINITIVA_ITINERARIO: 36,
    STRIP_ALTERACAO_PROVISORIA_ITINERARIO: 37,
    STRIP_INCLUSAO_TIPO_EQUIPAMENTO: 38,
    STRIP_SUBSTITUICAO_TIPO_EQUIPAMENTO: 39,
    STRIP_IMPLANTACAO_SECAO: 40,
    STRIP_SUPRESSAO_SECAO: 41,
    STRIP_CANCELAMENTO_LINHA: 42,
    STRIP_CANCELAMENTO_SERVICO: 43,
    STRIP_MODIFICACAO_HORARIOS: 44,
    STRIP_AMPLIACAO_HORARIOS: 45,
    STRIP_SUPRESSAO_HORARIOS: 46,
    STRIP_PRORROGACAO_PRAZO: 47,
    STRIP_TRANSFERENCIA_LINHA: 48,
    CHANGE_EMAIL: 49,
};

export const DOCUMENT_TYPE = {
    CNPJ: 1,
    CPF: 2,
};

export const LICENSE_CHAGES_TYPE = {
    SUBSTITUICAO_VEICULO: 1,
    MUDANCA_CONTRATO: 2,
    MUDANCA_RAZAO_SOCIAL: 3,
    ALTERAR_PROPRIETARIO_VEICULO: 4,
    MUDANCA_MUNICIPIO_VEICULO: 5,
    MUDANCA_ITINERARIO: 6,
};

export const ITINERARY_TYPES = {
    DISTANCIA_ENTRE_SECOES: 1,
    DISTACIA_CHEIA: 2,
};

export const SCHEDULES_TYPES = {
    PADRAO: 1,
    CIRCULAR: 2,
    ZERADO: 3,
    SAZONAL: 4,
};

export const SERVICES_GROUPS = {
    COMPANY: [
        SERVICES_CODES.ACESSO_PORTAL_FISICA,
        SERVICES_CODES.ACESSO_PORTAL_JURIDICA,
        SERVICES_CODES.INSCRICAO_CADASTRAL,
        SERVICES_CODES.RENOVACAO_CADASTRAL,
        SERVICES_CODES.ATUALIZACAO_CADASTRAL_COM_CRC,
        SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC,
        SERVICES_CODES.SEGUNDA_VIA_CRC,
        SERVICES_CODES.INATIVACAO_CADASTRAL,
        SERVICES_CODES.CHANGE_EMAIL,
    ],
    VEHICLES: [
        SERVICES_CODES.INCLUSAO_VEICULOS_SEM_CRC,
        SERVICES_CODES.ALTERACAO_VEICULOS_SEM_CRC,
        SERVICES_CODES.INCLUSAO_VEICULOS,
        SERVICES_CODES.ALTERACAO_VEICULOS,
        SERVICES_CODES.EXCLUSAO_VEICULOS,
    ],
    SURVEY: [SERVICES_CODES.VISTORIA, SERVICES_CODES.LAUDO_VISTORIA],
    LICENSE: [
        SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL,
        SERVICES_CODES.LICENCA_VINCULADA,
        SERVICES_CODES.LICENCA_FRETAMENTO,
        SERVICES_CODES.LICENCA_FRETAMENTO_TRATAMENTO_SAUDE,
        SERVICES_CODES.LICENCA_FRETAMENTO_UNIVERSITARIOS,
        SERVICES_CODES.LICENCA_ESCOLAR,
        SERVICES_CODES.LICENCA_TURISMO,
        SERVICES_CODES.LICENCA_SEGUNDA_VIA,
    ],
    LINES_SLIC: [
        SERVICES_CODES.SLIC_MODIFICACAO_HORARIOS,
        SERVICES_CODES.SLIC_AMPLIACAO_HORARIOS,
        SERVICES_CODES.SLIC_SUPRESSAO_HORARIOS,
        SERVICES_CODES.SLIC_SUBSTITUICAO_VEICULO,
        SERVICES_CODES.SLIC_PRORROGACAO_PRAZO,
        SERVICES_CODES.SLIC_TRANSFERENCIA_PERMISSAO,
        SERVICES_CODES.SLIC_CANCELAMENTO_PERMISSAO,
        SERVICES_CODES.SLIC_INCLUSAO_CONDUTOR_SUBSTITUTO,
    ],
    LINES_STRIP: [
        SERVICES_CODES.STRIP_PROLONGAMENTO_LINHA,
        SERVICES_CODES.STRIP_ENCURTAMENTO_LINHA,
        SERVICES_CODES.STRIP_REFORCO_HORARIOS,
        SERVICES_CODES.STRIP_CONEXAO_LINHAS,
        SERVICES_CODES.STRIP_ALTERACAO_DEFINITIVA_ITINERARIO,
        SERVICES_CODES.STRIP_ALTERACAO_PROVISORIA_ITINERARIO,
        SERVICES_CODES.STRIP_INCLUSAO_TIPO_EQUIPAMENTO,
        SERVICES_CODES.STRIP_SUBSTITUICAO_TIPO_EQUIPAMENTO,
        SERVICES_CODES.STRIP_IMPLANTACAO_SECAO,
        SERVICES_CODES.STRIP_SUPRESSAO_SECAO,
        SERVICES_CODES.STRIP_CANCELAMENTO_LINHA,
        SERVICES_CODES.STRIP_CANCELAMENTO_SERVICO,
        SERVICES_CODES.STRIP_MODIFICACAO_HORARIOS,
        SERVICES_CODES.STRIP_AMPLIACAO_HORARIOS,
        SERVICES_CODES.STRIP_SUPRESSAO_HORARIOS,
        SERVICES_CODES.STRIP_PRORROGACAO_PRAZO,
        SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA,
    ],
};

export const SERVICES_PROPERTIES = {
    [SERVICES_CODES.ACESSO_PORTAL_FISICA]: {
        title: 'Acesso Portal - Pessoa Física',
        url: URLS.PORTAL_ACCESS,
        component: InitialAccess,
        initials: 'APF',
        formInitialValues: accessPortalPayload,
        validationSchema: accessPortalSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.ACESSO_PORTAL_JURIDICA]: {
        title: 'Acesso Portal - Pessoa Jurídica',
        url: URLS.PORTAL_ACCESS,
        component: InitialAccess,
        initials: 'APJ',
        formInitialValues: accessPortalPayload,
        validationSchema: accessPortalSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.CHANGE_EMAIL]: {
        title: 'Alteração de E-mail',
        url: URLS.CHANGE_EMAIL,
        component: ChangeEmailRegistration,
        initials: 'AE',
        formInitialValues: changeEmailPayload,
        validationSchema: changeEmailSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.INSCRICAO_CADASTRAL]: {
        title: 'Inscrição cadastral',
        url: URLS.REGISTRATION,
        component: Company,
        initials: 'IC',
        formInitialValues: registrationPayload,
        validationSchema: registrationValidationSchema,
        hasCertification: true,
        hasRevisions: false,
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.RENOVACAO_CADASTRAL]: {
        title: 'Renovação cadastral',
        url: URLS.REGISTRATION,
        component: Company,
        initials: 'RC',
        formInitialValues: {},
        validationSchema: registrationValidationSchema,
        hasCertification: true,
        hasRevisions: true,
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.ATUALIZACAO_CADASTRAL_COM_CRC]: {
        title: 'Atualização cadastral - Com emissão CRC',
        url: URLS.REGISTRATION,
        component: Company,
        initials: 'ACC',
        formInitialValues: {},
        validationSchema: registrationValidationSchema,
        hasCertification: true,
        hasRevisions: true,
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC]: {
        title: 'Atualização cadastral - Sem emissão CRC',
        url: URLS.REGISTRATION,
        component: Company,
        initials: 'ACS',
        formInitialValues: {},
        validationSchema: registrationValidationSchema,
        hasCertification: false,
        hasRevisions: true,
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.SEGUNDA_VIA_CRC]: {
        title: 'Segunda Via do CRC',
        url: URLS.REGISTRATION,
        component: Company,
        initials: 'SVC',
        formInitialValues: {},
        validationSchema: registrationValidationSchema,
        hasCertification: true,
        hasRevisions: true,
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.INATIVACAO_CADASTRAL]: {
        title: 'Inativação - Baixa cadastral',
        url: URLS.REGISTRATION,
        component: Company,
        initials: 'IBC',
        formInitialValues: {},
        validationSchema: registrationValidationSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.INCLUSAO_VEICULOS_SEM_CRC]: {
        title: 'Inclusão de veículos - sem CRC',
        url: URLS.VEHICLES,
        component: VehicleRegistration,
        initials: 'IVC',
        formInitialValues: vehicleRequestPayload,
        validationSchema: vehicleValidationSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
        payloadDocumentsGrouper: 'veiculos',
        titleDocumentGrouper: 'Veículo(s)',
    },
    [SERVICES_CODES.INCLUSAO_VEICULOS]: {
        title: 'Inclusão de veículos',
        url: URLS.VEHICLES,
        component: VehicleRegistration,
        initials: 'IV',
        formInitialValues: vehicleRequestPayload,
        validationSchema: vehicleValidationSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
        payloadDocumentsGrouper: 'veiculos',
        titleDocumentGrouper: 'Veículo(s)',
    },
    [SERVICES_CODES.ALTERACAO_VEICULOS_SEM_CRC]: {
        title: 'Alteração de dados de veículos - sem CRC',
        url: URLS.VEHICLE_CHANGE,
        component: VehicleRegistration,
        initials: 'AVC',
        formInitialValues: vehicleRequestPayload,
        validationSchema: vehicleValidationSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
        payloadDocumentsGrouper: 'veiculos',
        titleDocumentGrouper: 'Veículo(s)',
    },
    [SERVICES_CODES.ALTERACAO_VEICULOS]: {
        title: 'Alteração de dados de veículos',
        url: URLS.VEHICLE_CHANGE,
        component: VehicleRegistration,
        initials: 'AV',
        formInitialValues: vehicleRequestPayload,
        validationSchema: vehicleValidationSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
        payloadDocumentsGrouper: 'veiculos',
        titleDocumentGrouper: 'Veículo(s)',
    },
    [SERVICES_CODES.EXCLUSAO_VEICULOS]: {
        title: 'Exclusão de veículos',
        url: URLS.VEHICLE_CHANGE,
        component: VehicleRegistration,
        initials: 'EV',
        formInitialValues: vehicleRequestPayload,
        validationSchema: null,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
        payloadDocumentsGrouper: 'veiculos',
        titleDocumentGrouper: 'Veículo(s)',
    },
    [SERVICES_CODES.VISTORIA]: {
        title: 'Solicitação de certificado de vistoria',
        url: URLS.SURVEY,
        component: SurveyRegistration,
        initials: 'SV',
        formInitialValues: surveyRequestPayload,
        validationSchema: surveyValidationSchema,
        hasCertification: true,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'vistoriaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
    },
    [SERVICES_CODES.LAUDO_VISTORIA]: {
        title: 'Laudo de vistoria',
        url: URLS.INSPECTION_REPORT,
        component: SurveyRegistration,
        initials: 'SV',
        formInitialValues: surveyRequestPayload,
        validationSchema: surveyValidationSchema,
        hasCertification: false,
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: false,
        payloadDocumentsGrouper: null,
        titleDocumentGrouper: 'Veículo(s)',
    },
    [SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL]: {
        title: 'Licença por viagem eventual',
        url: URLS.LICENSES_EVENTUAL,
        component: LicenseRegistration,
        initials: 'LVE',
        formInitialValues: licensePayload,
        validationSchema: licensesEventualValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            hasCompanyInfo: true,
            hasTypeSelector: false,
            hasVehicleSearch: true,
            hasTravelInformation: true,
            hasVehicle: false,
            hasItinerary: false,
            hasPassengers: true,
            hasSchedules: false,
            hasCompanies: false,
            hasAditionalData: false,
        },
    },
    [SERVICES_CODES.LICENCA_VINCULADA]: {
        title: 'Licença vinculada',
        url: URLS.LICENSES_LINKED,
        component: LicenseRegistration,
        initials: 'LVI',
        formInitialValues: licensePayload,
        validationSchema: licensesTourismValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            hasCompanyInfo: false,
            hasTypeSelector: true,
            hasVehicleSearch: false,
            hasTravelInformation: false,
            hasVehicle: true,
            hasItinerary: false,
            hasPassengers: false,
            hasSchedules: false,
            hasCompanies: false,
            hasAditionalData: true,
        },
    },
    [SERVICES_CODES.LICENCA_FRETAMENTO]: {
        title: 'Licença de fretamento',
        url: URLS.LICENSES_CHARTER,
        component: LicenseRegistration,
        initials: 'LFT',
        formInitialValues: licensePayload,
        validationSchema: licensesValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            hasCompanyInfo: false,
            hasTypeSelector: true,
            hasVehicleSearch: false,
            hasTravelInformation: false,
            hasVehicle: true,
            hasItinerary: true,
            hasPassengers: false,
            hasSchedules: true,
            hasCompanies: true,
            hasAditionalData: true,
        },
    },
    [SERVICES_CODES.LICENCA_FRETAMENTO_TRATAMENTO_SAUDE]: {
        title: 'Licença de fretamento - Tratamento de saúde',
        url: URLS.LICENSES_HEALTH,
        component: LicenseRegistration,
        initials: 'LFS',
        formInitialValues: licensePayload,
        validationSchema: healthLicenseValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            hasCompanyInfo: false,
            hasTypeSelector: true,
            hasVehicleSearch: false,
            hasTravelInformation: false,
            hasVehicle: true,
            hasItinerary: true,
            hasPassengers: false,
            hasSchedules: true,
            hasCompanies: true,
            hasAditionalData: true,
        },
    },
    [SERVICES_CODES.LICENCA_FRETAMENTO_UNIVERSITARIOS]: {
        title: 'Licença de fretamento - Grupo fixo / Universitários',
        url: URLS.LICENSES_STUDENTS,
        component: LicenseRegistration,
        initials: 'LFU',
        formInitialValues: licensePayload,
        validationSchema: licensesValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            hasCompanyInfo: false,
            hasTypeSelector: true,
            hasVehicleSearch: false,
            hasTravelInformation: false,
            hasVehicle: true,
            hasItinerary: true,
            hasPassengers: true,
            hasSchedules: true,
            hasCompanies: true,
            hasAditionalData: true,
        },
    },
    [SERVICES_CODES.LICENCA_ESCOLAR]: {
        title: 'Licença Escolar',
        url: URLS.LICENSES_SCHOOL,
        component: LicenseRegistration,
        initials: 'LES',
        formInitialValues: licensePayload,
        validationSchema: licensesValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            hasCompanyInfo: false,
            hasTypeSelector: true,
            hasVehicleSearch: false,
            hasTravelInformation: false,
            hasVehicle: true,
            hasItinerary: true,
            hasPassengers: true,
            hasSchedules: true,
            hasCompanies: true,
            hasAditionalData: true,
        },
    },
    [SERVICES_CODES.LICENCA_TURISMO]: {
        title: 'Licença de turismo',
        url: URLS.LICENSES_TOURISM,
        component: LicenseRegistration,
        initials: 'LTU',
        formInitialValues: licensePayload,
        validationSchema: licensesTourismValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            hasCompanyInfo: false,
            hasTypeSelector: true,
            hasVehicleSearch: false,
            hasTravelInformation: false,
            hasVehicle: true,
            hasItinerary: false,
            hasPassengers: false,
            hasSchedules: false,
            hasCompanies: false,
            hasAditionalData: true,
        },
    },
    [SERVICES_CODES.LICENCA_SEGUNDA_VIA]: {
        title: 'Licença - Segunda via',
        url: URLS.LICENSES_DUPLICATE,
        component: LicenseDuplicateRegistration,
        initials: 'LSV',
        formInitialValues: licensePayload,
        validationSchema: null,
        hasCertification: true,
        certificateTabTitle: 'Licenças',
        hasSurvey: false,
        hasRevisions: false,
        needDocumentToApprove: true,
        payloadDocumentsGrouper: 'licencaVeiculos',
        titleDocumentGrouper: 'Veículo(s)',
        configurator: {
            [LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO]: {
                hasVehicle: true,
            },
            [LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO]: {
                hasContract: true,
            },
            [LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL]: {
                hasCompanyName: true,
            },
            [LICENSE_CHAGES_TYPE.ALTERAR_PROPRIETARIO_VEICULO]: {
                hasVehicleOwner: true,
            },
            [LICENSE_CHAGES_TYPE.MUDANCA_MUNICIPIO_VEICULO]: {
                hasVehicleCity: true,
            },
            [LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO]: {
                hasItinerary: true,
            },
        },
    },
    [SERVICES_CODES.SLIC_MODIFICACAO_HORARIOS]: {
        title: 'SLIC - Modificação de horários',
        url: URLS.SLIC_LINES_MODIFY_SCHEDULE,
        component: LinesRegistration,
        initials: 'MH',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.SLIC_AMPLIACAO_HORARIOS]: {
        title: 'SLIC - Ampliação de horários',
        url: URLS.SLIC_LINES_EXPAND_SCHEDULE,
        component: LinesRegistration,
        initials: 'AH',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.SLIC_SUPRESSAO_HORARIOS]: {
        title: 'SLIC - Supressão de horários',
        url: URLS.SLIC_LINES_SUPRESS_SCHEDULE,
        component: LinesRegistration,
        initials: 'SH',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.SLIC_SUBSTITUICAO_VEICULO]: {
        title: 'SLIC - Substituição de veículo',
        url: URLS.SLIC_LINES_CHANGE_VEHICLE,
        component: LinesRegistration,
        initials: 'SV',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.SLIC_PRORROGACAO_PRAZO]: {
        title: 'SLIC - Prorrogação de prazo',
        url: URLS.SLIC_LINES_EXPIRATION_EXTENSION,
        component: LinesRegistration,
        initials: 'PPZ',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.SLIC_TRANSFERENCIA_PERMISSAO]: {
        title: 'SLIC - Transferência de permissão',
        url: URLS.SLIC_LINES_TRANSFER_PERMISSION,
        component: LinesRegistration,
        initials: 'TP',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.SLIC_CANCELAMENTO_PERMISSAO]: {
        title: 'SLIC - Cancelamento de permissão',
        url: URLS.SLIC_LINES_CANCEL_PERMISSION,
        component: LinesRegistration,
        initials: 'CP',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.SLIC_INCLUSAO_CONDUTOR_SUBSTITUTO]: {
        title: 'SLIC - Inclusão de condutor substituto',
        url: URLS.SLIC_LINES_SUBSTITUTE_CONDUCTOR,
        component: LinesRegistration,
        initials: 'ICS',
        formInitialValues: linePayload,
        validationSchema: lineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_PROLONGAMENTO_LINHA]: {
        title: 'STRIP - Prolongamento de Linha',
        url: URLS.STRIP_LINES_LINE_EXTENSION,
        component: LinesRegistration,
        initials: 'PL',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_ENCURTAMENTO_LINHA]: {
        title: 'STRIP - Encurtamento de Linha',
        url: URLS.STRIP_LINES_LINE_REDUCTION,
        component: LinesRegistration,
        initials: 'EL',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_REFORCO_HORARIOS]: {
        title: 'STRIP - Reforço de horários entre seções de uma linha',
        url: URLS.STRIP_LINES_SCHEDULE_REINFORCEMENT,
        component: LinesRegistration,
        initials: 'RH',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_CONEXAO_LINHAS]: {
        title: 'STRIP - Conexão de Linhas Intermunicipais',
        url: URLS.STRIP_LINES_LINE_CONNECTION,
        component: LinesRegistration,
        initials: 'CLI',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_ALTERACAO_DEFINITIVA_ITINERARIO]: {
        title: 'STRIP - Alteração definitiva de itinerário',
        url: URLS.STRIP_LINES_DEFINITIVE_ITINERARY_CHANGE,
        component: LinesRegistration,
        initials: 'ADH',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_ALTERACAO_PROVISORIA_ITINERARIO]: {
        title: 'STRIP - Alteração provisória de itinerário',
        url: URLS.STRIP_LINES_TEMPORARY_ITINERARY_CHANGE,
        component: LinesRegistration,
        initials: 'APH',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_INCLUSAO_TIPO_EQUIPAMENTO]: {
        title: 'STRIP - Inclusão do tipo de equipamento',
        url: URLS.STRIP_EQUIPMENT_TYPE_INCLUSION,
        component: LinesRegistration,
        initials: 'ITE',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_SUBSTITUICAO_TIPO_EQUIPAMENTO]: {
        title: 'STRIP - Substituição do tipo de equipamento',
        url: URLS.STRIP_EQUIPMENT_TYPE_REPLACEMENT,
        component: LinesRegistration,
        initials: 'STE',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_IMPLANTACAO_SECAO]: {
        title: 'STRIP - Implantação de seção',
        url: URLS.STRIP_SECTION_IMPLANTATION,
        component: LinesRegistration,
        initials: 'IS',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_SUPRESSAO_SECAO]: {
        title: 'STRIP - Supressão de seção',
        url: URLS.STRIP_SECTION_SUPPRESSION,
        component: LinesRegistration,
        initials: 'SS',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_CANCELAMENTO_LINHA]: {
        title: 'STRIP - Cancelamento de linha',
        url: URLS.STRIP_LINES_LINE_CANCEL,
        component: LinesRegistration,
        initials: 'CL',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.STRIP_CANCELAMENTO_SERVICO]: {
        title: 'STRIP - Cancelamento de serviço',
        url: URLS.STRIP_LINES_LINE_CANCEL,
        component: LinesRegistration,
        initials: 'CS',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.STRIP_MODIFICACAO_HORARIOS]: {
        title: 'STRIP - Modificação de horários',
        url: URLS.STRIP_SCHEDULES_EXTENSION,
        component: LinesRegistration,
        initials: 'MH',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_AMPLIACAO_HORARIOS]: {
        title: 'STRIP - Ampliação de horários',
        url: URLS.STRIP_SCHEDULES_MODIFICATION,
        component: LinesRegistration,
        initials: 'AH',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_SUPRESSAO_HORARIOS]: {
        title: 'STRIP - Supressão de horários',
        url: URLS.STRIP_SCHEDULES_SUPPRESSION,
        component: LinesRegistration,
        initials: 'SH',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
    [SERVICES_CODES.STRIP_PRORROGACAO_PRAZO]: {
        title: 'STRIP - Prorrogação de prazo',
        url: URLS.STRIP_DEADLINE_EXTENSION,
        component: LinesRegistration,
        initials: 'PP',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: false,
    },
    [SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA]: {
        title: 'STRIP - Transferência de linha',
        url: URLS.STRIP_LINES_LINE_TRANSFER,
        component: LinesRegistration,
        initials: 'TL',
        formInitialValues: lineStripPayload,
        validationSchema: stripLineValidationSchema,
        hasCertification: true,
        certificateTabTitle: 'Documento(s) gerado(s)',
        needDocumentToApprove: true,
    },
};

export const LINES_SITUATIONS = {
    EM_REVISAO: {
        name: 'Em revisão',
        code: 1,
    },
    VIGENTE: {
        name: 'Vigente',
        code: 2,
    },
    INATIVO: {
        name: 'Inativo',
        code: 3,
    },
};

export const slicLineRequestConfig = {
    withPermissionaries: [
        SERVICES_CODES.SLIC_MODIFICACAO_HORARIOS,
        SERVICES_CODES.SLIC_AMPLIACAO_HORARIOS,
        SERVICES_CODES.SLIC_SUPRESSAO_HORARIOS,
    ],
    withLineDetails: [
        SERVICES_CODES.SLIC_PRORROGACAO_PRAZO,
        SERVICES_CODES.SLIC_TRANSFERENCIA_PERMISSAO,
        SERVICES_CODES.SLIC_CANCELAMENTO_PERMISSAO,
    ],
    withVehicleChange: [SERVICES_CODES.SLIC_SUBSTITUICAO_VEICULO],
    withSucessor: [SERVICES_CODES.SLIC_TRANSFERENCIA_PERMISSAO],
    withSubstituteConductor: [SERVICES_CODES.SLIC_INCLUSAO_CONDUTOR_SUBSTITUTO],
};

export const stripLineRequestConfig = {
    withStripApostille: [SERVICES_CODES.STRIP_CANCELAMENTO_SERVICO],
    withStripEquipmentSelector: [
        SERVICES_CODES.STRIP_INCLUSAO_TIPO_EQUIPAMENTO,
        SERVICES_CODES.STRIP_SUBSTITUICAO_TIPO_EQUIPAMENTO,
    ],
    withStripPermissionAgreement: [
        SERVICES_CODES.STRIP_CANCELAMENTO_SERVICO,
        SERVICES_CODES.STRIP_CANCELAMENTO_LINHA,
        SERVICES_CODES.STRIP_PRORROGACAO_PRAZO,
        SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA,
    ],
    withStripSchedulesModification: [
        SERVICES_CODES.STRIP_MODIFICACAO_HORARIOS,
        SERVICES_CODES.STRIP_AMPLIACAO_HORARIOS,
        SERVICES_CODES.STRIP_SUPRESSAO_HORARIOS,
    ],
    withStripServiceField: [
        SERVICES_CODES.STRIP_ENCURTAMENTO_LINHA,
        SERVICES_CODES.STRIP_PROLONGAMENTO_LINHA,
        SERVICES_CODES.STRIP_REFORCO_HORARIOS,
        SERVICES_CODES.STRIP_INCLUSAO_TIPO_EQUIPAMENTO,
        SERVICES_CODES.STRIP_SUBSTITUICAO_TIPO_EQUIPAMENTO,
        SERVICES_CODES.STRIP_ALTERACAO_DEFINITIVA_ITINERARIO,
        SERVICES_CODES.STRIP_ALTERACAO_PROVISORIA_ITINERARIO,
    ],
    withStripServiceTime: [SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA],
    withStripDueDate: [SERVICES_CODES.STRIP_PRORROGACAO_PRAZO, SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA],
    withStripLineListSelector: [SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA],
};

export const CHANGE_EMAIL_SERVICE = {
    cdServico: SERVICES_CODES.CHANGE_EMAIL,
    nmServico: SERVICES_PROPERTIES[SERVICES_CODES.CHANGE_EMAIL].title,
    sgServico: SERVICES_PROPERTIES[SERVICES_CODES.CHANGE_EMAIL].initials,
    deServico: 'O serviço tem por objetivo permitir alterar o e-mail da empresa/pessoa física junto a AGERBA',
};
